const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Informazioni",
    "termsOfService": "Termini d'uso",
    "privacyPolicy": "Informativa sulla privacy",
    "guaranteeOfRights": "Diritti del titolare dei dati",
    "customerSupport": "ASSISTENZA",
    "cookiePolicy": "Informativa sui cookie",
    "declarationOfSafety": "Dichiarazione di・Sicurezza e Protezione",
    "youthProtectionPolicy": "Politica di tutela dei minori",
    "communityPolicy": "Politica della community",
    "probability": "probability",
    "operationPolicy": "Politica operativa",
    "doNotSell": "Non vendere le mie informazioni personali",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC 프라이버시 센터",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NCSOFT 서비스 동의",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Informazioni aggiuntive in conformità alle leggi sul gioco",
    "brandInformation": "Informazioni sul nome della compagnia",
    "copyright": "Copyright",
    "channelingInfo": "NCSOFT è un intermediario che media l'e-commerce di canalizzazione dei giochi all'interno di plaync, e non è parte delle vendite sopra menzionate.<br>Tutti gli obblighi e le responsabilità collegati alla canalizzazione dei giochi fornita sono attribuite alle parti e-commerce individuali, e non siamo responsabili per problemi ad essi relativi."
  },
  "infoCS": {
    "businessInformation": "Vedi le informazioni aziendali",
    "infoAddress": "Nome della compagnia: NCSOFT Corporation, Co-CEO: Kim Taek-Jin, Park Byung-Moo, Numero di registrazione aziendale: 144-85-04244, Registrazione e-commerce: 2013-Gyeonggi Seongnam-1268",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Indirizzo: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Repubblica di Corea. ASSISTENZA Clienti: +82 1566-7004. Fax: +82 02-2186-3499.",
    "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3555",
    "other": "Indirizzo: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Repubblica di Corea. ASSISTENZA Clienti: +82 1600-0020 (Giochi PC), +82 1566-7004 (Giochi mobile). Fax: +82 02-2186-3550 (Giochi PC), +82 02-2186-3499 (Giochi mobile).",
    "none": "",
    "infoEmail": "E-mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Titolo",
    "jpGenre": "Genere",
    "jpPrice": "Prezzo",
    "jpPriceValue": "Giocabile gratis (Contiene acquisti in-app)",
    "jpOs": "OS supportati",
    "jpDevelopedBy": "Sviluppatore/Editore",
    "jpReleaseDay": "Data di rilascio",
    "jpReleaseDayValue_LW": "4 novembre 2021"
  },
  "country": {
    "KR": "Corea, Repubblica di",
    "TW": "Taiwan",
    "RU": "Russia",
    "MY": "Malesia",
    "SA": "Arabia Saudita",
    "SG": "Singapore",
    "AE": "Emirati Arabi Uniti",
    "ID": "Indonesia",
    "JP": "Giappone",
    "QA": "Qatar",
    "TH": "Tailandia",
    "PH": "Filippine",
    "HK": "Hong Kong",
    "UA": "Ucraina",
    "BY": "Bielorussia",
    "LT": "Lituania",
    "PL": "Polonia",
    "GR": "Grecia",
    "IL": "Israele",
    "KW": "Kuwait",
    "AT": "Austria",
    "US": "Stati Uniti d'America",
    "CA": "Canada",
    "DE": "Germania",
    "GB": "Regno Unito",
    "FR": "Francia",
    "BR": "Brasile",
    "IT": "Italia",
    "ES": "Spagna",
    "CL": "Cile",
    "NO": "Norvegia",
    "SE": "Svezia",
    "IE": "Irlanda",
    "PT": "Portogallo",
    "FI": "Finlandia",
    "DK": "Danimarca",
    "CH": "Svizzera",
    "AR": "Argentina",
    "PE": "Perù",
    "MX": "Messico",
    "KZ": "Kazakistan",
    "UZ": "Uzbekistan",
    "AZ": "Azerbaigian",
    "GE": "Georgia",
    "MD": "Moldavia",
    "AM": "Armenia",
    "MO": "Macao",
    "IN": "India",
    "PK": "Pakistan",
    "NL": "Paesi Bassi",
    "RO": "Romania",
    "AU": "Australia",
    "TR": "Turchia",
    "EC": "Ecuador",
    "CO": "Colombia",
    "ZA": "Sud Africa",
    "EG": "Egitto",
    "NC": "Globale"
  }
};

export default l10n;
